import React from 'react';
import './NewApproachSection.css';

function NewApproachSection({
  tagline = 'A NEW APPROACH',
  headingRegular = 'It’s About Preventing Disease,',
  headingHighlighted = 'Not Just Fighting It.',
  mainImageSrc = '/images/creatives/landing-new-text-1.png',
  insetImgSrc = '/images/creatives/stethoscope-inset.jpg',
  logoSrc = '/images/icons/logo-shield.png',
  features = [
    {
      number: '01',
      title: 'Prevention over reaction',
      description: 'The clinic’s position is plain: up to 70% of cardiac events and cancers stem from preventable causes. We intervene early — precision testing, lifestyle work, and monitoring that does not wait for a crisis.'
    },
    {
      number: '02',
      title: 'Optimal health is a daily practice',
      description: 'Clinicians coach you in lifestyle and environment, turning evidence into a plan you can actually keep. Outcomes come from repetition, not a single impressive visit.'
    },
    {
      number: '03',
      title: 'Designed for longevity',
      description: 'The mission is simple: keep you healthy, high-performing, and independent for as long as possible. Treatment has a place. It is not the whole practice.'
    }
  ]
}) {
  return (
    <section className="ttc-approach-section py-5">
      <div className="container py-lg-4">
        <div className="row align-items-center gy-5">
          
          {/* Left Column: Image Stack */}
          <div className="col-12 col-lg-5">
            <div className="ttc-approach-img-wrapper position-relative">
              {/* Main Family & Doctor Image */}
              <img 
                src={mainImageSrc} 
                alt="Family care consultation" 
                className="img-fluid ttc-approach-main-img" 
              />


            </div>
          </div>

          {/* Right Column: Heading & Features List */}
          <div className="col-12 col-lg-7 ps-lg-5">
            {/* Tagline */}
            <div className="ttc-approach-tagline text-uppercase mb-3 d-flex align-items-center gap-2">
              <span className="ttc-approach-bullet">•</span>
              <span>{tagline}</span>
            </div>

            {/* Main Section Heading */}
            <h2 className="ttc-approach-heading mb-5">
              <span className="text-dark">{headingRegular}</span> <br />
              <span className="ttc-approach-blue-text">{headingHighlighted}</span>
            </h2>

            {/* Numbered Features */}
            <div className="ttc-approach-features-list d-flex flex-column gap-4">
              {features.map((item, index) => (
                <div key={index} className="d-flex align-items-start gap-4">
                  {/* Number Badge */}
                  <div className="ttc-approach-number">
                    {item.number}
                  </div>
                  
                  {/* Text Details */}
                  <div className="ttc-approach-feature-body pt-1">
                    <h3 className="ttc-approach-feature-title mb-2">
                      {item.title}
                    </h3>
                    <p className="ttc-approach-feature-desc mb-0">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default NewApproachSection;